import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=1ca232d8&"
import script from "./NewProjectModal.vue?vue&type=script&lang=js&"
export * from "./NewProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports